 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"canvg":"canvg","common":"common","modules-executive-executive-module":"modules-executive-executive-module","default~google-maps-google-maps-module~modules-admin-admin-module~modules-teacher-teacher-module":"default~google-maps-google-maps-module~modules-admin-admin-module~modules-teacher-teacher-module","default~adv-rating-adv-rating-module~modules-admin-admin-module~widget-chart-widget-chart-module":"default~adv-rating-adv-rating-module~modules-admin-admin-module~widget-chart-widget-chart-module","default~modules-admin-admin-module~modules-teacher-teacher-module":"default~modules-admin-admin-module~modules-teacher-teacher-module","default~crt-high-chart-crt-high-chart-module~modules-admin-admin-module":"default~crt-high-chart-crt-high-chart-module~modules-admin-admin-module","default~modules-admin-admin-module~widget-chart-widget-chart-module":"default~modules-admin-admin-module~widget-chart-widget-chart-module","modules-admin-admin-module":"modules-admin-admin-module","modules-teacher-teacher-module":"modules-teacher-teacher-module","demo-application-email-email-module":"demo-application-email-email-module","demo-application-gallery-gallery-module":"demo-application-gallery-gallery-module","demo-application-helpdesk-helpdesk-module":"demo-application-helpdesk-helpdesk-module","demo-application-task-task-module":"demo-application-task-task-module","demo-application-todo-todo-module":"demo-application-todo-todo-module","demo-dashboard-dashboard-module":"demo-dashboard-dashboard-module","demo-extension-editor-editor-module":"demo-extension-editor-editor-module","demo-extension-files-upload-files-upload-module":"demo-extension-files-upload-files-upload-module","demo-extension-full-event-calendar-full-event-calendar-module":"demo-extension-full-event-calendar-full-event-calendar-module","demo-extension-invoice-invoice-module":"demo-extension-invoice-invoice-module","demo-pages-core-chart-core-chart-module":"demo-pages-core-chart-core-chart-module","demo-pages-core-maps-core-maps-module":"demo-pages-core-maps-core-maps-module","demo-pages-form-elements-form-elements-module":"demo-pages-form-elements-form-elements-module","demo-pages-layout-layout-module":"demo-pages-layout-layout-module","demo-pages-maintenance-maintenance-module":"demo-pages-maintenance-maintenance-module","demo-pages-sample-page-sample-page-module":"demo-pages-sample-page-sample-page-module","demo-pages-tables-tbl-bootstrap-tbl-bootstrap-module":"demo-pages-tables-tbl-bootstrap-tbl-bootstrap-module","demo-pages-tables-tbl-datatable-tbl-datatable-module":"demo-pages-tables-tbl-datatable-tbl-datatable-module","demo-ui-elements-ui-adv-ui-adv-module":"demo-ui-elements-ui-adv-ui-adv-module","demo-ui-elements-ui-basic-ui-basic-module":"demo-ui-elements-ui-basic-ui-basic-module","demo-users-users-module":"demo-users-users-module","demo-widget-widget-module":"demo-widget-widget-module","dompurify":"dompurify","mail-compose-mail-compose-module":"mail-compose-mail-compose-module","mail-inbox-mail-inbox-module":"mail-inbox-mail-inbox-module","mail-read-mail-read-module":"mail-read-mail-read-module","modules-authentication-authentication-module":"modules-authentication-authentication-module","gallery-grid-gallery-grid-module":"gallery-grid-gallery-grid-module","gallery-masonry-gallery-masonry-module":"gallery-masonry-gallery-masonry-module","hd-customer-detail-hd-customer-detail-module":"hd-customer-detail-hd-customer-detail-module","hd-customer-hd-customer-module":"hd-customer-hd-customer-module","hd-customer-list-hd-customer-list-module":"hd-customer-list-hd-customer-list-module","hd-dashboard-hd-dashboard-module":"hd-dashboard-hd-dashboard-module","hd-ticket-hd-ticket-module":"hd-ticket-hd-ticket-module","task-board-task-board-module":"task-board-task-board-module","task-detail-task-detail-module":"task-detail-task-detail-module","task-list-task-list-module":"task-list-task-list-module","todo-list-todo-list-module":"todo-list-todo-list-module","dash-analytics-dash-analytics-module":"dash-analytics-dash-analytics-module","dash-sale-dash-sale-module":"dash-sale-dash-sale-module","ext-tinymce-ext-tinymce-module":"ext-tinymce-ext-tinymce-module","pell-wysiwyg-pell-wysiwyg-module":"pell-wysiwyg-pell-wysiwyg-module","invoice-basic-invoice-basic-module":"invoice-basic-invoice-basic-module","invoice-list-invoice-list-module":"invoice-list-invoice-list-module","invoice-summary-invoice-summary-module":"invoice-summary-invoice-summary-module","crt-apex-crt-apex-module":"crt-apex-crt-apex-module","crt-chart-js-crt-chart-js-module":"crt-chart-js-crt-chart-js-module","crt-peity-crt-peity-module":"crt-peity-crt-peity-module","crt-high-chart-crt-high-chart-module":"crt-high-chart-crt-high-chart-module","google-maps-google-maps-module":"google-maps-google-maps-module","basic-elements-basic-elements-module":"basic-elements-basic-elements-module","frm-advance-frm-advance-module":"frm-advance-frm-advance-module","frm-masking-frm-masking-module":"frm-masking-frm-masking-module","frm-picker-frm-picker-module":"frm-picker-frm-picker-module","frm-select-frm-select-module":"frm-select-frm-select-module","frm-validation-frm-validation-module":"frm-validation-frm-validation-module","frm-wizard-frm-wizard-module":"frm-wizard-frm-wizard-module","default~theme-box-theme-box-module~theme-collapse-menu-theme-collapse-menu-module~theme-dark-theme-d~7ff09aea":"default~theme-box-theme-box-module~theme-collapse-menu-theme-collapse-menu-module~theme-dark-theme-d~7ff09aea","theme-box-theme-box-module":"theme-box-theme-box-module","theme-collapse-menu-theme-collapse-menu-module":"theme-collapse-menu-theme-collapse-menu-module","theme-dark-theme-dark-module":"theme-dark-theme-dark-module","theme-fixed-theme-fixed-module":"theme-fixed-theme-fixed-module","theme-horizontal-l2-theme-horizontal-l2-module":"theme-horizontal-l2-theme-horizontal-l2-module","theme-horizontal-theme-horizontal-module":"theme-horizontal-theme-horizontal-module","theme-light-theme-light-module":"theme-light-theme-light-module","theme-nav-fixed-theme-nav-fixed-module":"theme-nav-fixed-theme-nav-fixed-module","theme-rtl-h-theme-rtl-h-module":"theme-rtl-h-theme-rtl-h-module","theme-rtl-v-theme-rtl-v-module":"theme-rtl-v-theme-rtl-v-module","theme-static-theme-static-module":"theme-static-theme-static-module","mainten-coming-soon-mainten-coming-soon-module":"mainten-coming-soon-mainten-coming-soon-module","mainten-error-mainten-error-module":"mainten-error-mainten-error-module","mainten-offline-ui-mainten-offline-ui-module":"mainten-offline-ui-mainten-offline-ui-module","tbl-basic-tbl-basic-module":"tbl-basic-tbl-basic-module","tbl-border-tbl-border-module":"tbl-border-tbl-border-module","tbl-sizing-tbl-sizing-module":"tbl-sizing-tbl-sizing-module","tbl-styling-tbl-styling-module":"tbl-styling-tbl-styling-module","adv-alert-adv-alert-module":"adv-alert-adv-alert-module","adv-light-box-adv-light-box-module":"adv-light-box-adv-light-box-module","adv-notification-adv-notification-module":"adv-notification-adv-notification-module","adv-range-slider-adv-range-slider-module":"adv-range-slider-adv-range-slider-module","adv-task-board-adv-task-board-module":"adv-task-board-adv-task-board-module","adv-rating-adv-rating-module":"adv-rating-adv-rating-module","basic-alert-basic-alert-module":"basic-alert-basic-alert-module","basic-badge-basic-badge-module":"basic-badge-basic-badge-module","basic-button-basic-button-module":"basic-button-basic-button-module","basic-cards-basic-cards-module":"basic-cards-basic-cards-module","basic-carousel-basic-carousel-module":"basic-carousel-basic-carousel-module","basic-collapse-basic-collapse-module":"basic-collapse-basic-collapse-module","basic-grid-basic-grid-module":"basic-grid-basic-grid-module","basic-modal-basic-modal-module":"basic-modal-basic-modal-module","basic-other-basic-other-module":"basic-other-basic-other-module","basic-progress-bar-basic-progress-bar-module":"basic-progress-bar-basic-progress-bar-module","basic-spinner-basic-spinner-module":"basic-spinner-basic-spinner-module","basic-tabs-pills-basic-tabs-pills-module":"basic-tabs-pills-basic-tabs-pills-module","basic-toasts-basic-toasts-module":"basic-toasts-basic-toasts-module","basic-tooltip-popovers-basic-tooltip-popovers-module":"basic-tooltip-popovers-basic-tooltip-popovers-module","basic-typography-basic-typography-module":"basic-typography-basic-typography-module","breadcrumb-paging-breadcrumb-paging-module":"breadcrumb-paging-breadcrumb-paging-module","user-profile-user-profile-module":"user-profile-user-profile-module","users-card-users-card-module":"users-card-users-card-module","users-list-users-list-module":"users-list-users-list-module","widget-chart-widget-chart-module":"widget-chart-widget-chart-module","widget-data-widget-data-module":"widget-data-widget-data-module","widget-statistic-widget-statistic-module":"widget-statistic-widget-statistic-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
